module.exports = __webpack_public_path__ + "static/img/no-more.568b5ed4.png";